// **  Initial State
const initialState = {
  loading: true,
  isAdmin: false,
  isDriver: false,
  isSender: false,
  merchants: [],
  permissions: [],
  profile: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
  case 'GET_PERMISSIONS':
    return {
      ...state,
      ...action.payload,
      loading: false,
    };
  case 'GET_USER_DETAILS':
    return {
      ...state,
      profile: action?.data?.data,
    };
  default:
    return state;
  }
};

export default authReducer;
